import React from 'react';
import styled, { css } from 'styled-components';

const HeaderLogo = styled.div`
	width: 32px;
	height: 32px;
	background-image: url('../assets/header_logo.svg');
	background-size: 100%;
	background-repeat: no-repeat;
	background-position: center;
	${({ $success }) =>
		$success &&
		css`
			width: 24px;
			height: 24px;
		`}
`;

const LogoWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	padding-bottom: 15px;
	margin: 24px 0;
	position: relative;
	${({ $success }) =>
		$success &&
		css`
			margin-bottom: 0;
		`}
	&::after {
		content: '';
		display: block;
		width: 100%;
		max-width: 327px;
		height: 1px;
		background: #d9ebf1;
		position: absolute;
		bottom: 0px;
		${({ $success }) =>
			$success &&
			css`
				width: 100vw;
				max-width: none;
			`}
	}
	@media screen and (max-width: 450px) {
		&::after {
			width: 100vw;
			max-width: none;
		}
	}
`;

const FLText = styled.div`
	font-weight: 500;
	font-size: 16px;
	line-height: 19px;
	color: #3393ec;
	${({ $success }) =>
		$success &&
		css`
			color: #323232;
			font-weight: 600;
		`}
`;

const AppHeaderLogo = ({ isSuccessScreen = false }) => (
	isSuccessScreen? (
		<LogoWrapper $success>
			<FLText $success>Family Locator</FLText>
			<HeaderLogo $success/>
		</LogoWrapper>
	) : (
		<LogoWrapper>
			<HeaderLogo />
			<FLText>Family Locator</FLText>
		</LogoWrapper>
	)
);

export default AppHeaderLogo;
